<template>
	<div style="width: 100vw;">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);"
			:style="{minHeight:`calc(100vh - ${placeNavHeight}px)` }">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<!-- <div style="height: 30px;width: 100%;"></div> -->
		<div :style="equipment == 'pc'?{
					// width:equipment == 'pc'?'1280px':'100%'
					...boxStyleOne,
					minHeight:`calc(100vh - ${placeNavHeight}px)`
				}:{
					maxWidth:'100%',
					minHeight:`calc(100vh - ${placeNavHeight}px)`
				}" style="display: flex;background-color: #ffffff;margin: auto;padding: 0px 20px;flex-direction: column;">
			<!-- <div style="width: 100px;height: 1000px;background-color: aqua;"></div> -->
			<div style="height: 30px;width: 1px;"></div>
			<div v-if="data">
				<div style="font-weight: bold;font-size: 20px;width: 100%;text-align: center;">
					{{data.page_format.title_format}}
				</div>
				<!-- <div
					style="margin-left: 10px;color: #b3b3b3;font-size: 16px;margin-top: 20px;display: flex;align-items: center;">
					<div>
						<i class="el-icon-user"></i> {{data.page_format.author}}
					</div>
					<div style="margin-left: 20px;">
						<i class="el-icon-time"></i> {{data.page_format.updated_at}}
					</div>
					<div style="margin-left: 20px;">
						<i class="el-icon-view"></i> {{data.page_format.views}}
					</div>
				</div> -->
			</div>
			<div style="height: 30px;width: 1px;"></div>
			<div v-if="data" class="ql-container ql-snow" style="border:none;">
				<div class="ql-editor" style="width: fit-content;border:none; ">
					<div v-html="data.page_format.content">
					</div>
				</div>
			</div>

			<div v-if="data && data.products.length > 0" :style="getColumns()"
				style="max-width: 100%;display: grid;margin-top: 10px;justify-content: space-around;">
				<single-goods style="max-width: 100%;" v-for="(item,index) in data.products" :key="index" :goodsData="{
						...item,
						image_format:item.images[0]
					}" :equipment="equipment" :selectdItem="selectdItem" type="build"></single-goods>
			</div>

			<!-- <div v-if="data && data.products.length > 0" style="width: 100%;">
				<div style="margin: auto;text-align: center;">{{$t('h.linkGoods')}}</div>
				<div style="margin-top: 30px;display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;">
					<div v-if="data.products.length > 0" @click="navTo(item)" :style="{
						boxShadow:selectItem &&  selectItem.id == item.id?' 0 0 10px 1px #999 ':'none',
						width: equipment == 'pc'?'300px':'46%',height: equipment == 'pc'?'auto':'auto',
						marginLeft: equipment == 'pc'?'30px':'4px'
					}" @mouseleave.stop.prevent="leaveGoods" @mouseenter.stop.prevent="entGood(item)"
						style="margin-top: 20px;cursor: pointer;" v-for="(item,index) in  data.products" :key="index">
						<div style="position: relative;width: 100%;">
							<img style="width: 100%;aspect-ratio: 1/1;"
								:src="item.images && item.images.length > 0?item.images[0]:''" />
							<div v-if="selectItem &&  selectItem.id == item.id"
								style="height: 40px;background-color: #000;width: 100%;display: flex;color: #fff;position: absolute;bottom: 0px;align-items: center;justify-content: space-between;">
								<div @click.stop.prevent="addCart(item)"
									style="width: 80%;border-right: solid 1px #aaaaaa;height: 100%;display: flex;justify-content: center;align-items: center;">
									{{$t('h.addCart')}}</div>
								<div @click.stop.prevent="collect(item)"
									style="width: 20%;text-align: center;font-size: 18px;" v-if="item.in_wishlist == 0">
									<i style="color: #fff;" class="el-icon-star-off"></i>
								</div>
								<div @click.stop.prevent="collect(item)"
									style="width: 20%;text-align: center;font-size: 18px;" v-if="item.in_wishlist != 0">
									<i style="color: #fff;" class="el-icon-star-on"></i>
								</div>
							</div>
						</div>
						<div :style="{
						 	width:equipment == 'pc'?'300px':'100%'
						 }" style="text-align: center;margin-top: 10px;" class="tit">
							{{item.name_format}}
						</div>
						<div :style="{
							width:equipment == 'pc'?'300px':'100%',
							marginLeft: equipment == 'pc'?'0px':'0px'
						}" style="display: flex;justify-content: center;margin-top: 10px;">
							<div style="color: #635bff;">
								{{item.price_format}}
							</div>
							<div class="original-price" style="margin-bottom: 10px;margin-left: 10px;">
								{{item.origin_price_format}}
							</div>
						</div>
					</div>
				</div>
			</div> -->
		</div>
		<!-- <div style="height: 30px;width: 100%;"></div> -->
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import lodash from 'lodash';
	import singleGoods from '../../components/singleGoods.vue'
	import "quill/dist/quill.core.css"; // import styles
	import "quill/dist/quill.snow.css"; // for snow theme
	import "quill/dist/quill.bubble.css"; // for bubble theme
	import {
		getPagesData
	} from '../../../api/all.js'
	export default {
		components: {
			singleGoods
		},
		props: {
			footerHeight: {
				type: Number,
				default: 0
			},
			boxStyleTwo: {
				type: Object,
				default: () => {
					return {}
				}
			},
			boxStyleOne: {
				type: Object,
				default: () => {
					return {}
				}
			},
			placeNavHeight: {
				type: Number,
				default: 0
			},
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				selectdItem: {
					compontChildren: [{
						layoutConfig: {
							classFiyConfig: {
								paginationHoverColor: "#55aaff",
								paginationSelectColor: "#55aaff"
							},
							goodsConfig: {}
						}
					}]
				},
				iframeLogin: false,
				dialogVisible: false,
				isCollct: false,
				selectItem: null,
				data: null,
				loading: false
			}
		},
		
		watch: {
			$route: {
				deep: true,
				handler: async function(to, from) {
					this.getData()	
				}
			}
		},
		computed: {
			...mapState("lowCodeStore", ['goodsConfig', 'classifyListPreview']),
		},
		mounted() {
			if (this.goodsConfig.length > 0) {
				console.log('classifyListPreview', this.classifyListPreview)
				if (this.classifyListPreview.length > 0) {

					this.classifyListPreview.forEach(item => {
						if (item.name == '商品分类') {
							this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig = lodash.cloneDeep(item
								.children[0].children[0].compontChildren[0].layoutConfig.classFiyConfig)
						}
					})

					// this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig = this.classifyListPreview[0].compontChildren[0].layoutConfig.classFiyConfig
				}
				this.selectdItem.compontChildren[0].layoutConfig.goodsConfig = lodash.cloneDeep(this.goodsConfig[0])
				this.$forceUpdate()
			}

			this.getData()
			let that = this
			// window.addEventListener('message', function(event) {
			// 	console.log('eventeventevent', event)
			// 	if (event && event.data.data.status == "success") {
			// 		that.dialogVisible = false
			// 		localStorage.setItem('address', JSON.stringify(event.data.data.data))
			// 		// that.$message.success(event.data.data.message)
			// 	}
			// });
		},
		methods: {
			getColumns() {
				let goodsConfig = lodash.cloneDeep(this.goodsConfig[0])
				let num = 1
				if (this.equipment == 'pc') {
					num = goodsConfig.pcNum
				} else {
					num = goodsConfig.phoneNum
				}
				
				let gridRowGap;
				let gridColumnGap;
				if(this.equipment == 'pc'){
					gridRowGap = goodsConfig.rowGap + 'px'
					gridColumnGap = goodsConfig.columnGap + 'px'
				}else{
					gridRowGap = goodsConfig.phoneRowGap + 'px'
					gridColumnGap = goodsConfig.phoneColumnGap + 'px'
				}
				
				console.log('getColumnsgridRowGap',gridRowGap)
				console.log('gridColumnGap',gridColumnGap)
				return {
					gridRowGap: gridRowGap,
					gridColumnGap: gridColumnGap,
					gridTemplateColumns: `repeat(auto-fill, calc(${parseInt(100 / num)}% - ${this.equipment == 'pc'?goodsConfig.columnGap: goodsConfig.phoneColumnGap}px))`
				}
			},
			async addCart(item) {
				try {
					console.log(this.sku)
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let data = await getAccountAddCarts({
						wsid,
						buy_now: false,
						sku_id: item.sku_id,
						quantity: 1
					})
					this.$message.success(data.data.message)
					this.loading = false
				} catch (e) {
					console.log('e', e)
					this.$message.error(e.response.data.message)
					this.loading = false
				}
			},
			async collect(item) {
				console.log('item', item)
				try {
					console.log(this.sku)
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let data = await getAccountCollect({
						wsid,
						product_id: item.id
					})
					console.log(data)
					this.$message.success(data.data.message)
					this.loading = false
					if (item.in_wishlist == 0) {
						item.in_wishlist = 1
					} else {
						item.in_wishlist = 0
					}
					// this.isCollct = !this.isCollct
				} catch (e) {
					if (e.status == 401) {
						this.dialogVisible = true
						this.iframeLogin = true
					}
					this.loading = false
					console.log('e', e)

				}
			},
			navTo(item) {
				this.$router.push({
					path: '/products/' + item.url_name,

				})
			},
			leaveGoods() {
				this.selectItem = null
			},
			entGood(item) {
				this.selectItem = item
			},
			async getData() {
				try {
					this.loading = true
					console.log('getData', this.$route)
					const data = await getPagesData({
						id: this.$route.params.id
					})
					this.data = data.data.data
					console.log('data', data)
					this.loading = false
				} catch (e) {
					this.loading = false
				}

			}
		}
	}
</script>

<style scoped>
	.tit {
		display: -webkit-box;
		/* 设置为WebKit内核的弹性盒子模型 */
		-webkit-box-orient: vertical;
		/* 垂直排列 */
		-webkit-line-clamp: 1;
		/* 限制显示两行 */
		overflow: hidden;
		/* 隐藏超出范围的内容 */
		text-overflow: ellipsis;
	}
</style>